import axios from ".";

const management = {
  reportLeakage: (data) => axios.post("/accounts/report-leakage", data),
};

export default management;
